<div class="backdrop" *ngIf="isOpen" (click)="close()"></div>
<div class="drawer" [class.open]="isOpen">
<ng-content></ng-content>
</div>